import { useEffect } from "react";
import { gsap } from "gsap";

interface SkewZAnimationProps {
    svgElement: SVGElement;
    skewAngle: number,
    animationSpeed: number;
  }

  const SkewZAnimation: React.FC<SkewZAnimationProps> = ({
    svgElement,
    skewAngle = 20,
    animationSpeed = 1,
  }) => {
    useEffect(() => {
      gsap.to(svgElement, {
        skewZ: skewAngle,
        duration: animationSpeed,
        ease: "power1.inOut",
        repeat: -1,
        yoyo: true,
      });
    }, [svgElement, skewAngle, animationSpeed]);
  
    return null;
  };
   
export default SkewZAnimation;
